<section id="dynamic-category-header-2345674" class="dynamic-header-background">
  <div class="header-layout-12">
    <div class="top-section">
      <div class="logo-hamburger-wrapper">
        @if (headerData.menuListVisibleOnMobile) {
          <img (click)="toggleHamburgerMenu()" class="hamburger-btn" [src]="headerData.hamburgerMenuIcon" />
        }

        <!-- mobile logo icon -->
        @if (headerData.logo.isVisibleOnMobile && selectedDeviceTypeInput() === device.mobile) {
          <a [routerLink]="['/']" class="logo"><img class="static-header-logo" [src]="headerData.logo.logoSrc" /> </a>
        } @else {
          <!-- desktop logo icon -->
          @if (headerData.logo.isVisibleOnDesktop && selectedDeviceTypeInput() === device.desktop) {
            <a [routerLink]="['/']" class="logo"><img class="static-header-logo" [src]="headerData.logo.logoSrc" /> </a>
          }
        }
      </div>

      @if (!isSearchOverlay && headerData.searchIcon.isVisibleOnDesktop) {
        <base-search-bar
          class="only-desktop"
          [searchSuggestionConfiguration]="headerData && headerData.searchSuggestionConfiguration"
          [selectedDeviceType]="selectedDeviceTypeInput()"
          [headerData]="headerData"
          (searchProduct$)="searchProduct($event)"
          [searchInputControl]="searchInputControl"
          (searchIconClick$)="searchIconClick()"
          [isFocused]="isSearchOverlay"
        ></base-search-bar>
      }

      <div class="operation-button-container">
        <!-- Desktop search Icon -->
        @if (headerData.searchIcon.isVisibleOnDesktop && selectedDeviceTypeInput() === device.desktop) {
          <a
            class="button search-btn button cart-btn header-cart-indicator operation-button dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius"
            (click)="toggleSearchDropDown()"
          >
            <img [src]="headerData.searchIcon.searchIconSrc" />
          </a>
        } @else {
          <!-- Mobile search Icon -->
          @if (headerData.searchIconMobile.isVisibleOnMobile && selectedDeviceTypeInput() === device.mobile) {
            <a
              class="button search-btn button cart-btn header-cart-indicator operation-button dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius"
              (click)="toggleSearchDropDown()"
            >
              <img [src]="headerData.searchIcon.searchIconSrc" />
            </a>
          }
        }
        <!-- Desktop contact icon -->
        @if (headerData.contactIcon?.isVisibleOnDesktop && selectedDeviceTypeInput() === device.desktop) {
          <a
            [href]="'tel:' + headerData.contactIcon?.contactNo"
            class="contact-btn only-desktop header-contact-indicator"
          >
            <img class="header-contact-icon" [src]="headerData.contactIcon?.contactIconSrc" />

            <div class="contact-info">
              <span class="number-message-text header-editable-text dynamic-icon-content-text-color">{{
                headerData.contactIcon?.contactNoTextContent
              }}</span>
              <span class="mobile-number header-editable-text dynamic-icon-content-text-color">{{
                headerData.contactIcon?.contactNo
              }}</span>
            </div>
          </a>
        }

        <!-- mobile account icon -->
        @if (headerData.accountIcon.isVisibleOnMobile && selectedDeviceTypeInput() === device.mobile) {
          <a
            (click)="isHamburgerMenu = false; onLinkClick($event)"
            class="button operation-button dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius header-account-indicator header-account-icon"
            [target]="headerData.accountIcon.target"
            [attr.data-click_action_value]="headerData.accountIcon['data-click_action_value']"
            [attr.data-click_action_choice]="headerData.accountIcon['data-click_action_choice']"
            [attr.data-section_type]="UTM_MEDIUM"
          >
            <img [src]="headerData.accountIcon.accountIconSrc" />
          </a>
        } @else {
          <!-- desktop account icon -->
          @if (headerData.accountIcon.isVisibleOnDesktop && selectedDeviceTypeInput() === device.desktop) {
            <a
              class="button operation-button dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius header-account-indicator header-account-icon"
              [target]="headerData.accountIcon.target"
              [attr.data-click_action_value]="headerData.accountIcon['data-click_action_value']"
              [attr.data-click_action_choice]="headerData.accountIcon['data-click_action_choice']"
              [attr.data-section_type]="UTM_MEDIUM"
            >
              <img [src]="headerData.accountIcon.accountIconSrc" />
            </a>
          }
        }

        <!-- mobile cart icon -->
        @if (headerData.cartIcon.isVisibleOnMobile && selectedDeviceTypeInput() === device.mobile) {
          <a
            (click)="isHamburgerMenu = false"
            class="button cart-btn header-cart-indicator operation-button dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius"
            [target]="headerData.cartIcon.target"
            [attr.data-click_action_value]="headerData.cartIcon['data-click_action_value']"
            [attr.data-click_action_choice]="headerData.cartIcon['data-click_action_choice']"
            [attr.data-section_type]="UTM_MEDIUM"
          >
            <img [src]="headerData.cartIcon.cartIconSrc" />

            <span
              class="cart-count dynamic-cart-count-text-color dynamic-cart-count-background dynamic-cart-count-border-color dynamic-cart-count-border-radius"
              >{{ cart?.cart_items?.length ?? 0 }}</span
            >
          </a>
        } @else {
          <!-- desktop cart icon -->
          @if (headerData.cartIcon.isVisibleOnDesktop && selectedDeviceTypeInput() === device.desktop) {
            <a
              class="button cart-btn header-cart-indicator operation-button dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius"
              [target]="headerData.cartIcon.target"
              [attr.data-click_action_value]="headerData.cartIcon['data-click_action_value']"
              [attr.data-click_action_choice]="headerData.cartIcon['data-click_action_choice']"
              [attr.data-section_type]="UTM_MEDIUM"
            >
              <img [src]="headerData.cartIcon.cartIconSrc" />

              <span
                class="cart-count dynamic-cart-count-text-color dynamic-cart-count-background dynamic-cart-count-border-color dynamic-cart-count-border-radius"
                >{{ cart?.cart_items?.length ?? 0 }}</span
              >
            </a>
          }
        }
      </div>
    </div>

    <div class="bottom-section dynamic-header-background">
      <!-- desktop navigation menu -->
      @if (headerData.menuListVisibleOnDesktop) {
        <nav #changeHeaderElement class="navigation-wrapper mega-menu-category">
          <ul class="navigation-list static-nav dynamic-menu-alignment">
            @for (staticMenu of headerData.menuItems; track staticMenu.id) {
              @if (staticMenu.text !== 'Category Header') {
                <li class="static-menu">
                  <div class="category-image-text-wrapper">
                    <div class="category-image-wrapper">
                      <img
                        [id]="staticMenu.id"
                        class="category-image"
                        [src]="staticMenu.categoryImage || IMAGE_URLS.productEmptyState"
                        [attr.data-click_action_value]="staticMenu['data-click_action_value']"
                        [attr.data-click_action_choice]="staticMenu['data-click_action_choice']"
                        [attr.data-section_type]="UTM_MEDIUM"
                      />
                    </div>
                    <a
                      [ngClass]="{
                        'hover-color-active': showActiveColor && currentMenuId === staticMenu.id,
                        'hover-color-inactive': !showActiveColor && currentMenuId === staticMenu.id,
                      }"
                      [id]="staticMenu.id"
                      class="static-header dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color dynamic-header-hover-text-color hoverMenu"
                      [target]="staticMenu.target"
                      [attr.data-click_action_value]="staticMenu['data-click_action_value']"
                      [attr.data-click_action_choice]="staticMenu['data-click_action_choice']"
                      [attr.data-section_type]="UTM_MEDIUM"
                      >{{ staticMenu.text }}</a
                    >
                  </div>

                  @if (staticMenu.subMenu?.length) {
                    <div
                      (mouseenter)="onMenuMouseEnter(staticMenu.id)"
                      (mouseleave)="removeHoverStyle()"
                      class="submenu-container dynamic-sub-menu-background hide-sub-menu-header"
                    >
                      @for (subMenu of staticMenu.subMenu; track subMenu.id) {
                        <ul class="submenu">
                          <li>
                            <div class="category-image-text-wrapper border-bottom-menu">
                              <div class="category-image-wrapper">
                                <img
                                  [id]="subMenu.id"
                                  class="category-image padding-bottom"
                                  [src]="subMenu.categoryImage || IMAGE_URLS.productEmptyStateBlack"
                                  [attr.data-click_action_value]="subMenu['data-click_action_value']"
                                  [attr.data-section_type]="UTM_MEDIUM"
                                  [attr.data-click_action_choice]="subMenu['data-click_action_choice']"
                                />
                              </div>
                              <a
                                (click)="onLinkClick($event)"
                                [target]="subMenu.target"
                                [attr.data-click_action_value]="subMenu['data-click_action_value']"
                                [attr.data-click_action_choice]="subMenu['data-click_action_choice']"
                                [attr.data-section_type]="UTM_MEDIUM"
                                [id]="subMenu.id"
                                class="dynamic-header-sub-menu-text-color dynamic-font-size-sub-menu dynamic-font-weight-sub-menu hoverSubMenu"
                              >
                                {{ subMenu.text }}</a
                              >
                            </div>
                          </li>
                          @if (subMenu.subMenu?.length) {
                            @for (subSubMenu of subMenu.subMenu; track subSubMenu.id) {
                              <li>
                                <div class="category-image-text-wrapper">
                                  <div class="category-image-wrapper">
                                    <img
                                      [id]="subSubMenu.id"
                                      class="category-image"
                                      [src]="subSubMenu.categoryImage || IMAGE_URLS.productEmptyStateBlack"
                                      [attr.data-section_type]="UTM_MEDIUM"
                                      [attr.data-click_action_value]="subSubMenu['data-click_action_value']"
                                      [attr.data-click_action_choice]="subSubMenu['data-click_action_choice']"
                                    />
                                  </div>
                                  <a
                                    [target]="subSubMenu.target"
                                    (click)="onLinkClick($event)"
                                    [attr.data-click_action_value]="subSubMenu['data-click_action_value']"
                                    [attr.data-click_action_choice]="subSubMenu['data-click_action_choice']"
                                    [attr.data-section_type]="UTM_MEDIUM"
                                    [id]="subSubMenu.id"
                                    class="dynamic-header-sub-sub-menu-text-color dynamic-font-size-sub-sub-menu dynamic-font-weight-sub-sub-menu hoverSubMenu"
                                    >{{ subSubMenu.text }}</a
                                  >
                                </div>
                              </li>
                            }
                          }
                        </ul>
                      }
                    </div>
                  }
                </li>
              }
            }

            <div class="dynamic-header" #dynamicCategoryHeader>
              @if (dynamicHeaderInline() && layoutType === 'inlineLayout1') {
                @for (parentCategory of category; track parentCategory.id; let i = $index) {
                  <li>
                    <div class="category-image-text-wrapper">
                      <div class="category-image-wrapper">
                        <img
                          (click)="filterProductsByCategory(parentCategory?.url_path || ''); onLinkClick($event)"
                          class="category-image"
                          [src]="parentCategory.category_images || IMAGE_URLS.productEmptyState"
                        />
                      </div>
                      <a
                        [ngClass]="{
                          'hover-color-active': showActiveColor && currentMenuId === parentCategory.id,
                          'hover-color-inactive': !showActiveColor && currentMenuId === parentCategory.id,
                        }"
                        (click)="filterProductsByCategory(parentCategory?.url_path || ''); onLinkClick($event)"
                        class="dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color hoverMenu non-editable"
                        >{{ parentCategory.name }}</a
                      >
                    </div>
                    @if (parentCategory?.sub_categories?.length) {
                      <div
                        (mouseenter)="onMenuMouseEnter(parentCategory.id)"
                        (mouseleave)="removeHoverStyle()"
                        class="submenu-container hide-sub-menu-header dynamic-sub-menu-background"
                      >
                        @for (childCategory of parentCategory.sub_categories; track childCategory.id) {
                          <ul class="submenu">
                            <li>
                              <div class="category-image-text-wrapper border-bottom-menu">
                                <div class="category-image-wrapper">
                                  <img
                                    (click)="
                                      filterProductsByCategory(childCategory?.url_path || ''); onLinkClick($event)
                                    "
                                    class="category-image padding-bottom"
                                    [src]="childCategory.category_images || IMAGE_URLS.productEmptyStateBlack"
                                  />
                                </div>
                                <a
                                  (click)="filterProductsByCategory(childCategory?.url_path || ''); onLinkClick($event)"
                                  class="dynamic-header-sub-menu-text-color dynamic-font-size-sub-menu dynamic-font-weight-sub-menu hoverSubMenu"
                                >
                                  {{ childCategory.name }}</a
                                >
                              </div>
                            </li>
                            @if (childCategory.sub_categories?.length) {
                              @for (subCategory of childCategory.sub_categories; track subCategory.id) {
                                <li>
                                  <div class="category-image-text-wrapper">
                                    <div class="category-image-wrapper">
                                      <img
                                        (click)="
                                          filterProductsByCategory(subCategory?.url_path || ''); onLinkClick($event)
                                        "
                                        class="category-image padding-bottom"
                                        [src]="subCategory.category_images || IMAGE_URLS.productEmptyStateBlack"
                                      />
                                    </div>
                                    <a
                                      (click)="
                                        filterProductsByCategory(subCategory?.url_path || ''); onLinkClick($event)
                                      "
                                      class="dynamic-header-sub-sub-menu-text-color dynamic-font-size-sub-sub-menu dynamic-font-weight-sub-sub-menu hoverSubMenu"
                                      >{{ subCategory.name }}</a
                                    >
                                  </div>
                                </li>
                              }
                            }
                          </ul>
                        }
                      </div>
                    }
                  </li>
                }
              }

              @if (dynamicHeaderHover() && layoutType === 'hoverLayout1') {
                <li>
                  <a
                    (click)="onLinkClick($event)"
                    class="dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color dynamic-header-hover-text-color hoverMenu"
                  >
                    <div class="category-image-group-text-wrapper">
                      <div class="category-group-image-wrapper non-editable">
                        <img
                          class="category-menu-image category-combine-image non-editable"
                          [src]="headerData.categoryMenuImage || IMAGE_URLS.categoryEmptyState"
                        />
                      </div>
                      {{ headerData.categoryMenuName }}
                    </div>
                  </a>
                  @if (category) {
                    <div class="submenu-container hide-sub-menu-header dynamic-sub-menu-background">
                      @for (parentCategory of category; track parentCategory.id) {
                        <ul class="submenu">
                          <li>
                            <div class="category-image-text-wrapper">
                              <div class="category-image-wrapper">
                                <img
                                  class="category-image"
                                  [src]="parentCategory.category_images || IMAGE_URLS.productEmptyStateBlack"
                                  (click)="
                                    filterProductsByCategory(parentCategory?.url_path || ''); onLinkClick($event)
                                  "
                                />
                              </div>
                              <a
                                [ngClass]="{
                                  'hover-color-active': showActiveColor && currentMenuId === parentCategory.id,
                                  'hover-color-inactive': !showActiveColor && currentMenuId === parentCategory.id,
                                }"
                                (click)="filterProductsByCategory(parentCategory?.url_path || ''); onLinkClick($event)"
                                class="title dynamic-header-sub-menu-text-color dynamic-font-size-sub-menu dynamic-font-weight-sub-menu hoverSubMenu"
                                >{{ parentCategory.name }}</a
                              >
                            </div>
                          </li>
                          @if (parentCategory.sub_categories?.length) {
                            @for (list of parentCategory.sub_categories; track list.id) {
                              <li (mouseenter)="onMenuMouseEnter(parentCategory.id)" (mouseleave)="removeHoverStyle()">
                                <div class="category-image-group-text-wrapper">
                                  <div class="category-group-image-wrapper non-editable">
                                    <img
                                      class="category-menu-image category-combine-image non-editable"
                                      [src]="parentCategory.category_images || IMAGE_URLS.productEmptyStateBlack"
                                    />
                                  </div>
                                  <a
                                    class="dynamic-header-sub-sub-menu-text-color dynamic-font-size-sub-sub-menu dynamic-font-weight-sub-sub-menu hoverSubMenu"
                                    (click)="filterProductsByCategory(list?.url_path || ''); onLinkClick($event)"
                                    >{{ list.name }}</a
                                  >
                                </div>
                              </li>
                            }
                          }
                        </ul>
                      }
                    </div>
                  }
                </li>
              }
            </div>
          </ul>
        </nav>
      }
    </div>

    @if (isSearchOverlay && headerData.searchIcon.isVisibleOnDesktop) {
      <div class="search-drop-down-container" (click)="toggleSearchDropDown()">
        <div class="search-drop-down dynamic-header-background" (click)="$event.stopPropagation()">
          <h5 class="dynamic-header-text-color">Start your amazing search :</h5>

          <button class="close-btn" (click)="toggleSearchDropDown()">
            <img
              src="https://assets.hyperinvento.com/hyperinventory_admin/dynamic-home-assets/common/close-line-icon.png"
            />
          </button>

          <base-search-bar
            [searchSuggestionConfiguration]="headerData && headerData.searchSuggestionConfiguration"
            [selectedDeviceType]="selectedDeviceTypeInput()"
            [headerData]="headerData"
            (searchProduct$)="searchProduct($event)"
            [searchInputControl]="searchInputControl"
            (searchIconClick$)="searchIconClick()"
            [isFocused]="isSearchOverlay"
          ></base-search-bar>
        </div>
      </div>
    }

    <!--  side menu for mobile -->
    @if (isHamburgerMenu && headerData.menuListVisibleOnMobile) {
      <div appClickOutside #changeHeaderMobileElement class="hamburger-menu-container" (click)="toggleHamburgerMenu()">
        <div class="hamburger-menu mobile-category-panel" (click)="$event.stopPropagation()">
          <static-menu-collapse
            [headerData]="headerData"
            [headerLayout]="HeaderLayout.headerLayout12"
            (hideMenu$)="toggleHamburgerMenu()"
          >
          </static-menu-collapse>
          @if (
            (dynamicHeaderInline() && layoutType === 'inlineLayout1') ||
            (dynamicHeaderHover() && layoutType === 'hoverLayout1')
          ) {
            <webstore-dynamic-menu-collapse
              #dynamicCategoryHeaderMobile
              [categories]="category || []"
              [menuCollapseIcon]="headerData.menuCollapseIcon"
              [headerLayout]="HeaderLayout.headerLayout12"
              (hideMenu$)="toggleHamburgerMenu()"
            ></webstore-dynamic-menu-collapse>
          }
        </div>
      </div>
    }
  </div>
</section>
